import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  quickResultsSetIsLoadingReducerType,
  quickResultsSetAllResultsReducerType,
  quickResultsSetPreviewResultsReducerType,
  quickResultsSetStructureReducerType,
  quickResultsSetStructurePreviewReducerType,
  quickResultsSetQueryReducerType,
  quickResultsSetIsQueryEnabledReducerType,
  quickResultsSetIsBioactivityVisualizationButtonEnabledPreviewReducerType,
  quickResultsSetIsResultsPreviewReadyReducerType,
  quickResultsShouldTrackSearchResultsReducerType,
  quickResultsSetRequestIdReducerType,
  quickResultsSetSearchIdReducerType,
  quickResultsResetStateReducerType,
} from './QuickResultsConstants';

export const initialState = Map({
  isLoading: false,
  allResults: [],
  previewResults: [],
  structure: null,
  structurePreview: null,
  query: null,
  isQueryEnabled: false,
  isSubstanceResultOptimizationEnabled: false,
  isBioactivityVisualizationButtonEnabled: false,
  isResultsPreviewReady: false,
  shouldTrackSearchResults: false,
  requestId: null,
  searchId: null,
});

const spec = {
  [quickResultsSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [quickResultsSetAllResultsReducerType]: (state, action) => {
    const { allResults } = action.payload;
    return state.set('allResults', allResults);
  },
  [quickResultsSetPreviewResultsReducerType]: (state, action) => {
    const { previewResults } = action.payload;
    return state.set('previewResults', previewResults);
  },
  [quickResultsSetStructureReducerType]: (state, action) => {
    const { structure } = action.payload;
    return state.set('structure', structure);
  },
  [quickResultsSetStructurePreviewReducerType]: (state, action) => {
    const { structurePreview } = action.payload;
    return state.set('structurePreview', structurePreview);
  },
  [quickResultsSetQueryReducerType]: (state, action) => {
    const { query } = action.payload;
    return state.set('query', query);
  },
  [quickResultsSetIsQueryEnabledReducerType]: (state, action) => {
    const { isQueryEnabled } = action.payload;
    return state.set('isQueryEnabled', isQueryEnabled);
  },
  [quickResultsSetIsBioactivityVisualizationButtonEnabledPreviewReducerType]: (state, action) => {
    const { isBioactivityVisualizationButtonEnabled } = action.payload;
    return state.set('isBioactivityVisualizationButtonEnabled', isBioactivityVisualizationButtonEnabled);
  },
  [quickResultsSetIsResultsPreviewReadyReducerType]: (state, action) => {
    const { isResultsPreviewReady } = action.payload;
    return state.set('isResultsPreviewReady', isResultsPreviewReady);
  },
  [quickResultsShouldTrackSearchResultsReducerType]: (state, action) => {
    const { shouldTrackSearchResults } = action.payload;
    return state.set('shouldTrackSearchResults', shouldTrackSearchResults);
  },
  [quickResultsSetRequestIdReducerType]: (state, action) => {
    const { requestId } = action.payload;
    return state.set('requestId', requestId);
  },
  [quickResultsSetSearchIdReducerType]: (state, action) => {
    const { searchId } = action.payload;
    return state.set('searchId', searchId);
  },
  [quickResultsResetStateReducerType]: () => {
    return initialState;
  },
};

export default createReducerBySpec(spec, initialState);
